import { Button, ButtonGroup, HStack, IconButton } from '@chakra-ui/react';
import { MinusIcon, PlusIcon } from '@repo/shared/shared';
import { useTranslation } from 'next-i18next';
import { useCartStoreActions, useSubscribeCartStoreWithShallow } from '../../hooks/cartStoreHooks';
import { cartStoreSelectors } from '../../selectors';

interface CartItemProps {
  itemSlug: string;
}

const CartItemQuantity = ({ itemSlug }: CartItemProps) => {
  const { t } = useTranslation();
  const quantity = useSubscribeCartStoreWithShallow(
    cartStoreSelectors.itemQuantityBySlug(itemSlug),
  );

  const { incItemQuantity, decItemQuantity } = useCartStoreActions();

  return (
    <HStack>
      <ButtonGroup
        colorScheme='gray'
        isAttached
        size='xs'
        variant='outline'
      >
        <IconButton
          aria-label={t('store.cart.quantity.decrease')}
          borderRight={0}
          icon={<MinusIcon boxSize={3} />}
          isDisabled={quantity <= 1}
          onClick={() => decItemQuantity(itemSlug)}
        />
        <Button
          _hover={{ cursor: 'default' }}
          borderX={0}
          fontSize='sm'
        >
          {quantity}
        </Button>
        <IconButton
          aria-label={t('store.cart.quantity.increase')}
          borderLeft={0}
          icon={<PlusIcon boxSize={3} />}
          onClick={() => incItemQuantity(itemSlug)}
        />
      </ButtonGroup>
    </HStack>
  );
};

export default CartItemQuantity;
